export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: 'v1/admin/auth/login',
    FORGOT_PASSWORD: 'v1/users/forgot-password',
    REFRESH_TOKEN: 'v1/auth/refresh-token',
  },
  CONFIG: {
    SETTINGS: 'v1/config/settings',
    TERMS: 'v1/config/terms',
  },
};
